<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import PhotoBox from "@/components/PhotoBox.vue";
import { formatedDate } from "../../../utils/proposalValidation";

export default {
  name: "FPTemp3",
  components: {
    SpellCheckedText,
    PhotoBox
  },
  props: ["proposal"],
  computed: {
    projectSlots() {
      const images = this.proposal.projects;
      const slots = [];

      for (let i = 0; i < 4; i++) {
        slots.push(images[i] || null);
      }

      return {
        line1: slots.slice(0, 2),
        line2: slots.slice(2, 4),
      };
    }
  },
  methods: {
    formatedDate
  }
};
</script>


<template>
  <div class="main-container" :style="{
    '--header-color': proposal.style.colorScheme && proposal.style.colorScheme.header,
    '--body-color': proposal.style.colorScheme && proposal.style.colorScheme.body,
    '--footer-color': proposal.style.colorScheme && proposal.style.colorScheme.footer,
    '--heading-color': proposal.style.heading.color,
    '--heading-size': proposal.style.heading.size + 'px',
    '--heading-font': proposal.style.heading.font,
    '--heading-bold': proposal.style.heading.bold ? 700 : 400,
    '--heading-italic': proposal.style.heading.italic ? 'italic' : 'normal',
    '--heading-underline': proposal.style.heading.underline
      ? 'underline'
      : 'none',
    '--label-color': proposal.style.label.color,
    '--label-size': proposal.style.label.size + 'px',
    '--label-font': proposal.style.label.font,
    '--label-bold': proposal.style.label.bold ? 700 : 400,
    '--label-italic': proposal.style.label.italic ? 'italic' : 'normal',
    '--label-underline': proposal.style.label.underline
      ? 'underline'
      : 'none',
    '--text-color': proposal.style.text.color,
    '--text-size': proposal.style.text.size + 'px',
    '--text-font': proposal.style.text.font,
    '--text-bold': proposal.style.text.bold ? 700 : 400,
    '--text-italic': proposal.style.text.italic ? 'italic' : 'normal',
    '--text-underline': proposal.style.text.underline ? 'underline' : 'none',
  }">
    <div class="frontPage">
      <div class="header-sec">
        <div class="banner" />
        <div class="logo-sec photobox">
          <PhotoBox :project="proposal" type="logo" bgColor="transparent" objectFit="contain" />
        </div>
      </div>

      <div class="projects-sec1 photobox">
        <div v-for="(project, index) in projectSlots.line1" :key="'l1-' + index"
          :class="index === 0 ? 'img-half' : 'img-full'">
          <PhotoBox v-if="project" :project="project" :height="index === 0 ? '240px' : '320px'" objectFit="fill" />
          <div v-else :class="`imageBox ${index === 0 ? 'img-half' : 'img-full'}`" />
        </div>
      </div>

      <div class="projects-sec2 photobox">
        <div v-for="(project, index) in projectSlots.line2" :key="'l2-' + index"
          :class="index === 0 ? 'img-full' : 'img-half'">
          <PhotoBox v-if="project" :project="project" :height="index === 0 ? '320px' : '240px'" objectFit="fill"
            :bgColor="proposal.style.colorScheme && proposal.style.colorScheme.body" />
          <div v-else :class="`imageBox ${index === 0 ? 'img-full' : 'img-half'}`" />
        </div>
      </div>

      <div class="details-sec">
        <div class="blankBox" />
        <div class="info-sec">
          <div class="detail-sec">
            <p>
              <SpellCheckedText :value="proposal.name || ''" @input="proposal.name = $event" />
            </p>
            <p>
              <SpellCheckedText :value="proposal.address || ''" @input="proposal.address = $event" />
              <span>{{ proposal.address ? ', ' : '' }}</span>
              <SpellCheckedText :value="proposal.city || ''" @input="proposal.city = $event" />
              <span>{{ proposal.city ? ', ' : '' }}</span>
              <SpellCheckedText :value="proposal.stateProvince || ''" @input="proposal.stateProvince = $event" />
            </p>
          </div>

          <div class="submission-sec">
            <div>
              <h5>SUBMISSION DATE</h5>
              <p>
                {{ formatedDate(proposal.submissionDate, "/") }}
              </p>
            </div>

            <div>
              <h5>SUBMITTED BY</h5>
              <p>
                <SpellCheckedText :value="proposal.submittedBy || ''" @input="proposal.submittedBy = $event" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped lang="scss">
.main-container {
  display: block;
  width: 211mm;
  height: 296.83mm;
  min-height: 296.83mm;
  position: relative;
  box-sizing: border-box;
  background: white;

  &:hover {
    .photobox :deep(.photo-overlay) {
      opacity: 1;
    }

    .photobox :deep(img) {
      opacity: 0.9;
    }
  }

  .frontPage {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    .banner {
      background: var(--header-color);
      min-height: 80px;
    }

    .header-sec {
      display: grid;
      grid-template-columns: 3fr 1fr;
      gap: 20px;
      width: 100%;
      margin-bottom: 50px;

      .logo-sec {
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--header-color);
        width: 193px;
        height: 80px;
      }
    }

    .details-sec {
      display: flex;
      flex-direction: row;
      width: 100%;
      align-items: stretch;

      .blankBox {
        width: 220px;
        min-width: 220px;
        background: var(--footer-color);
        margin-right: 30px;
      }

      .info-sec {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 25px;
        width: 100%;
        background: var(--body-color);
        padding: 20px 40px;
        height: 322.8px;

        .detail-sec {
          display: flex;
          flex-direction: column;
          gap: 10px;
          text-align: center;
          padding: 0px 10px;
          padding-bottom: 20px;
          border-bottom: 3px solid white;

          p {
            margin: 0px;
            color: var(--heading-color);
            font-family: var(--heading-font);
            font-size: var(--heading-size);
            font-weight: var(--heading-bold);
            font-style: var(--heading-italic);
            text-decoration: var(--heading-underline);
          }
        }

        .submission-sec {
          display: flex;
          justify-content: space-between;
          text-align: center;

          h5 {
            color: var(--label-color);
            font-size: var(--label-size);
            font-family: var(--label-font);
            font-weight: var(--label-bold);
            font-style: var(--label-italic);
            text-decoration: var(--label-underline);
            margin-bottom: 0px;
          }

          p {
            color: var(--text-color);
            font-size: var(--text-size);
            font-family: var(--text-font);
            font-weight: var(--text-bold);
            font-style: var(--text-italic);
            text-decoration: var(--text-underline);
          }
        }
      }
    }

    .projects-sec1 {
      display: grid;
      grid-template-columns: 3fr 2fr;
      gap: 30px;
      align-items: flex-start;
      margin-bottom: -20px;
    }

    .projects-sec2 {
      display: grid;
      grid-template-columns: 2fr 3fr;
      gap: 30px;
      align-items: flex-end;
      margin-bottom: 50px;
    }

    .project-img {
      object-fit: fill;
    }

    .img-full {
      width: 100%;
      height: 320px;
    }

    .img-half {
      width: 100%;
      height: 240px;
    }

    .imageBox {
      background: var(--body-color);
      width: 100%;
      max-height: 320px;
    }
  }
}
</style>